<template>
    <div>
        <div class="top-level-menu-status-list">
            <top-level-menu-status-item-view v-for="statusItem in statusItems"
                                             :statusItem="statusItem"
                                             :selectedItem="selectedItem"
                                             :isFirstStatusAfterLogin="isFirstStatusAfterLogin"
                                             :hasConfigForCustomMaxSize="hasConfigForCustomMaxSize"
                                             :expanded="customReasonsOpen ? 'true' : 'false'"
                                             :canExpand="canExpand(statusItem)"
                                             v-bind:key="statusItem.value"
                                             @clicked="itemClicked"
                                             @setFirstStatusToFalse="setFirstStatusToFalse">

            </top-level-menu-status-item-view>
        </div>
        <div v-bind:class="customReasonsClass">
            <top-level-menu-custom-reason-item-view v-for="customReason in extendedCustomAwayReasons"
                                                    :customReason="customReason"
                                                    :key="customReason.id"
                                                    @clicked="itemClicked">
            </top-level-menu-custom-reason-item-view>
        </div>
    </div>
</template>

<script>
    import * as CONST from 'const';
    import TopLevelMenuStatusItemView from './TopLevelMenuStatusItemView';
    import TopLevelMenuCustomReasonItemView from './TopLevelMenuCustomReasonItemView';
    import { leDialog } from 'lp-vue-components';


    export default {
        name: "top-level-menu-status-list",
        props: {
            statusItems: {
            type: Object,
            required: true,
            },
            selectedItem: {
            type: Object,
            required: true,
            },
            extendedCustomAwayReasons: {
            type: Object,
            required: true,
            },
            hasConfigForCustomMaxSize: {
            type: Boolean,
            default: false,
            }
        },
        data() {
            return {
              isFirstStatusAfterLogin: true,
                customReasonsOpen: false,
                CONST,
            }
        },
      computed: {
            customReasonsClass() {
                return {
                    'top-level-menu-custom-reasons-list theme-light': true,
                    'hide': !this.customReasonsOpen
                }
            }
        },
        methods: {
            toggleCustomReasons: function () {
                this.customReasonsOpen = !this.customReasonsOpen;
            },
            setFirstStatusToFalse() {
              if (this.isFirstStatusAfterLogin) {
                this.isFirstStatusAfterLogin = false;
              }
            },
            clicked() {
              this.$emit('clicked', this.statusItem);
            },
            itemClicked(item) {
            if (this.hasConfigForCustomMaxSize && item.customReasonsAvailable) {
                this.$emit('displayFilteredCustomAwaySatuses', CONST.AGENT_MENU_VIEWS.AWAY_STATUSES);
            } else if (item.customReasonsAvailable) {
                this.toggleCustomReasons();
            } else {
                this.$emit('clicked', item);
                if (this.customReasonsOpen) {
                this.toggleCustomReasons();
                }
            }
            },
            canExpand(item) {
            return (
                item.customReasonsAvailable &&
                ((this.isAwayStatus(item) && !this.hasConfigForCustomMaxSize) || !this.isAwayStatus(item))
            );
            },
            isAwayStatus({ value = '' }) {
                return value === CONST.DEFAULT_AGENT_STATUSES.away.value;
            },
        },
        components: {
            TopLevelMenuStatusItemView,
            TopLevelMenuCustomReasonItemView,
            leDialog,
        }
    }
</script>

<style scoped>

</style>
